<template>
    <div class="item-number-select-wrapper" :class="{ 'ms-4': !isDiverse, 'ms-3 me-3' : isDiverse }">
        <div>
            <div class="number-select-js row">
                <div class="col-5 col-lg-3">
                    <label :for="`item-${index}-adults`" class="fw-bold">{{item.personLabel}}:</label>
                </div>
                <div class="col-6 col-lg-6 d-flex mb-2">
                    <span class="change-count text-white" @click="removeAdult(index)" aria-hidden="true"
                    >&ndash;</span>
                    <input class="form-control align-middle remove-validation-background"
                         v-model="item.adults" type="number" min="0" :id="`item-${index}-adults`"
                         @change="validate()">
                    <span @click="addAdult(index)" class="change-count" aria-hidden="true"
                    >+</span>
                </div>
            </div>
        </div>
        <div v-if="item.renderChildren">
            <div class="number-select-js row">
                <div class="col-5 col-lg-3 ">
                    <label :for="`item-${index}-children`" class="fw-bold">
                      {{ $t('item.person.child', 2) }}:
                    </label>
                </div>
                <div class="col-6 col-lg-6 d-flex mb-2">
                    <span @click="removeChildren(index)" class="change-count" aria-hidden="true"
                    >&ndash;</span>
                    <input :value="item.children.length" type="number" min="0"
                           :id="`item-${index}-children`" class="form-control remove-validation-background"
                           :data-index="index"
                           @change="updateChildren"
                    >
                    <span @click="addChildren(index)" class="change-count" aria-hidden="true"
                    >+</span>
                </div>
            </div>
            <div v-if="item.renderChildAge" class="children" v-for="(child, childIndex) in item.children">
                <div class="child form-group row mb-2">
                    <div class="col-5 col-lg-3 col-form-label pl-5">
                        <label :for="`item-${index}-child-age-${childIndex}`" class="fw-bold">
                          {{ $t('item.person.child', 1) }} {{ childIndex+1 }}:</label>
                    </div>
                    <div class="col-5 col-lg-3">
                        <select v-model="child.age"
                                required
                                :id="`item-${index}-child-age-${childIndex}`"
                                class="form-control form-select w-auto"
                                @change="validate"
                        >
                            <option value="" disabled selected>{{ $t('item.age.title') }}</option>
                            <option v-for="i in 18" :key="i" :value="i-1">{{ i -1 }} {{$t('item.age.year', i-1) }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="(count, index) in item.counts" class="more-count">
            <div class="number-select-js row">
                <div class="col-5 col-lg-3 ">
                    <label :for="'item-more-'+index+''" class="fw-bold">{{count.label}}:</label>
                </div>
                <div class="col-6 col-lg-3 d-flex">
                    <span @click="count.decrement()" class="change-count">-</span>
                    <input v-model="count.count" type="number" min="0" :id="'item-more-'+index+''"
                           class="form-control remove-validation-background" @change="validate()">
                    <span @click="count.increment()" class="change-count">+</span>
                </div>
            </div>
        </div>

        <div v-if="hasError" class="form-group" :class="{ 'is-invalid': hasError }">
            <div class="invalid-feedback">
                {{hasError}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'step',
            'moreCountLabels',
            'index',
            'item',
            'isDiverse',
            'mandatory'
        ],
        data() {
            return {
                hasError: false,
            };
        },
        created() {
            if (this.moreCountLabels) {
                for (let i = 0; i < this.moreCountLabels.length; i++) {
                    const label = this.moreCountLabels[i];
                    this.item.addCount(label);
                }
            }
        },
        methods: {
            validate() {
                this.hasError = false;
                this.$emit('changed');
                const item = this.step.getItemByIndex(this.index);
                if (this.mandatory && item.adults + item.children.length === 0) {
                    this.hasError = this.$t('mod.peopleConfigurator.errors.atLeastOne')
                } else {
                    if (item.renderChildAge) {
                        for (let i = 0; i < item.children.length; i++) {
                            if (!item.children[i].hasAge) {
                                this.hasError = this.$t('mod.peopleConfigurator.errors.ageMissing')
                            }
                        }
                    }
                }
                return !this.hasError;
            },
            removeAdult(index) {
                const item = this.step.getItemByIndex(index);
                item.adults = Math.max(item.adults - 1, 0);
                this.validate();
            },
            addChildren(index) {
                const item = this.step.getItemByIndex(index);
                item.addChild();
                this.validate();
            },
            removeChildren(index, childIndex) {
                const item = this.step.getItemByIndex(index);
                item.removeChild(childIndex);
                this.validate();
            },
            updateChildren(event) {
              const item = this.step.getItemByIndex(event.currentTarget.dataset.index);
              const newChildrenCount = event.currentTarget.value;
              item.setChildrenCount(newChildrenCount)
            },
            addAdult(index) {
                const item = this.step.getItemByIndex(index);
                item.adults = item.adults + 1;
                this.validate();
            },
        },
    }
</script>